import * as React from "react";
import { Route, Switch } from "react-router";

import { JobContainer } from "./details/jobContainer";
import { JobsContainer } from "./search/jobsContainer";

export const JobsFeature = () => (
    <Switch>
        <Route path="/jobs/:jobId/" exact component={JobContainer} />
        <Route path="/jobs" exact component={JobsContainer} />
    </Switch>
);
